export default __webpack_public_path__ + "static/media/burger-2-640w.10fe5178.jpg";